import * as z from 'zod';

// Types
import { MediaZod } from '@/types/MediaType';
import { ArticleZod } from '@/types/Blog/ArticleType';

const AuthorZod = z.object({
  id: z.number(),
  documentId: z.string(),
  name: z.string(),
  avatar: MediaZod.nullish(),
  email: z.string().nullish(),
  get articles() {
    return z.array(ArticleZod).nullish();
  },
});

export { AuthorZod };
export type AuthorType = z.infer<typeof AuthorZod>;
